import { v4 as uuidv4 } from "uuid";
import userImagePlaceholder1 from "@circle-react-shared/BuilderUI/Assets/user_1_image_placeholder.png";
import userImagePlaceholder2 from "@circle-react-shared/BuilderUI/Assets/user_2_image_placeholder.png";
import userImagePlaceholder3 from "@circle-react-shared/BuilderUI/Assets/user_3_image_placeholder.png";
import userImagePlaceholder4 from "@circle-react-shared/BuilderUI/Assets/user_4_image_placeholder.png";
import userImagePlaceholder5 from "@circle-react-shared/BuilderUI/Assets/user_5_image_placeholder.png";
import userImagePlaceholder6 from "@circle-react-shared/BuilderUI/Assets/user_6_image_placeholder.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { getPaddingOptions } from "../../../utils/boxModelStyleHelpers";
import { getBlogBlockPrimaryStyleOptions } from "../../Blog/constants";
import { createH2Block, createPBlock } from "../../utils/textBlocksHelpers";
import { createBlogListingItemBlock } from "../BlogListingItemBlock/BlogListingItemBlockDefaultData";
import imagePlaceholder1 from "../BlogListingItemBlock/image_placeholder_1.png";
import imagePlaceholder2 from "../BlogListingItemBlock/image_placeholder_2.png";
import imagePlaceholder3 from "../BlogListingItemBlock/image_placeholder_3.png";
import imagePlaceholder4 from "../BlogListingItemBlock/image_placeholder_4.png";
import imagePlaceholder5 from "../BlogListingItemBlock/image_placeholder_5.png";
import imagePlaceholder6 from "../BlogListingItemBlock/image_placeholder_6.png";

const items = [
  {
    header: "Apr 11, 2025 · Member experience",
    title: "Designing your first member experience flow",
    description:
      "Learn how to build a seamless onboarding journey that welcomes, guides, and activates new members.",
    image: {
      signedId: "",
      placeholder: imagePlaceholder1,
    },
    userCard: {
      image: {
        signedId: "",
        placeholder: userImagePlaceholder1,
      },
      header: "James Carter",
      description: "Business growth coach",
    },
  },
  {
    header: "Mar 12, 2025 · Platform tools",
    title: "Building a branded resource library",
    description:
      "A practical guide to creating a scalable and styled content hub for member resources and shared knowledge.",
    image: {
      signedId: "",
      placeholder: imagePlaceholder2,
    },
    userCard: {
      image: {
        signedId: "",
        placeholder: userImagePlaceholder2,
      },
      header: "Sarah Mitchell",
      description: "Leadership coach",
    },
  },
  {
    header: "Mar 8, 2025 · Community insights",
    title: "From passive to participatory: rethinking community value",
    description:
      "Explore how professional groups are evolving beyond content delivery to enable real member-led contribution.",
    image: {
      signedId: "",
      placeholder: imagePlaceholder3,
    },
    userCard: {
      image: {
        signedId: "",
        placeholder: userImagePlaceholder3,
      },
      header: "Olivia Hayes",
      description: "Career dev. coach",
    },
  },
  {
    header: "Mar 5, 2025 · Editorial",
    title: "The case for slow growth in credentialed communities",
    description:
      "Why intentional, trust-based engagement is key to building sustainable member networks in regulated spaces.",
    image: {
      signedId: "",
      placeholder: imagePlaceholder4,
    },
    userCard: {
      image: {
        signedId: "",
        placeholder: userImagePlaceholder4,
      },
      header: "Emily Dawson",
      description: "Team dynamics coach",
    },
  },
  {
    header: "Mar 5, 2025 · Design & UX",
    title: "Creating modular content blocks for editorial portals",
    description:
      "Design reusable components that support events, profiles, announcements, and board updates.",
    image: {
      signedId: "",
      placeholder: imagePlaceholder5,
    },
    userCard: {
      image: {
        signedId: "",
        placeholder: userImagePlaceholder5,
      },
      header: "James Hartwell",
      description: "Performance coach",
    },
  },
  {
    header: "Mar 5, 2025 · Information architecture",
    title: "Structuring multi-tier navigation for member platforms",
    description:
      "Best practices for designing navigation that supports complex structures like chapters, committees, and topics.",
    image: {
      signedId: "",
      placeholder: imagePlaceholder6,
    },
    userCard: {
      image: {
        signedId: "",
        placeholder: userImagePlaceholder6,
      },
      header: "Daniel Brooks",
      description: "Entrepreneurial coach",
    },
  },
];

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "BlogListingBlock1",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Blog",
          paragraphStyle: "p3",
          styles: {
            textAlign: getTextAlignOptions("center"),
          },
        }),
        createH2Block({
          text: "Insights & ideas for growing leaders",
          styles: {
            textAlign: getTextAlignOptions("center"),
          },
        }),
        createPBlock({
          text: "A curated library of expert guidance, real-world strategies, and community stories.",
          styles: {
            textAlign: getTextAlignOptions("center"),
          },
        }),
      ],
    },
    items: {
      prop: "children",
      type: "children",
      value: items.map(item => createBlogListingItemBlock(item)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlogBlockPrimaryStyleOptions(),
        padding: getPaddingOptions({
          defaultValue: {
            paddingTop: "20",
            paddingBottom: "20",
            paddingLeft: "20",
            paddingRight: "20",
          },
        }),
      },
    },
  },
};
